export { default } from './StartingRates';
